export default "__VITE_ASSET__CPBHmsgI__"